// extracted by mini-css-extract-plugin
module.exports = {"yes":"styles__yes___1dLBO","no":"styles__no___lxQsY"};